import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useMedicalRecordExport = (medicalRecordId: string) => {
  return useQuery({
    queryKey: ["medical-record-export", medicalRecordId],
    enabled: Boolean(medicalRecordId),
    queryFn: async () => {
      // Buscar medical_record com TODAS as relações
      const { data: record, error: recordError } = await supabase
        .from("medical_records")
        .select(`
          *,
          pets!inner (
            id, name,
            breeds (name),
            species (name),
            owners (
              id, name,
              owners_phones (phone_number, is_primary)
            )
          ),
          profiles!fk_vet_user (
            id, full_name, crmv_state, crmv_number, mapa_number
          ),
          clinics (id, name)
        `)
        .eq("id", medicalRecordId)
        .single();

      if (recordError) throw recordError;

      // Transform profiles array to single object
      const transformedRecord = {
        ...record,
        profiles: Array.isArray(record.profiles) && record.profiles.length > 0 
          ? record.profiles[0] 
          : record.profiles,
      };

      // Buscar vacinas aplicadas nesta consulta
      const { data: vaccinations } = await supabase
        .from("pet_applications")
        .select(`
          *,
          items!item_id (name, description, manufacturer)
        `)
        .eq("medical_record_id", medicalRecordId)
        .order("application_date", { ascending: false });

      // Buscar exames desta consulta
      const { data: examResults } = await supabase
        .from("exam_results")
        .select("*")
        .eq("medical_record_id", medicalRecordId)
        .order("created_at", { ascending: false });

      // Buscar prescrições desta consulta
      const { data: prescriptions } = await supabase
        .from("medical_prescriptions")
        .select(`
          *,
          medical_prescription_items (*),
          medical_prescription_exam_items (*)
        `)
        .eq("medical_record_id", medicalRecordId)
        .order("issued_at", { ascending: false });

      return {
        record: transformedRecord as any,
        vaccinations: vaccinations || [],
        examResults: examResults || [],
        prescriptions: prescriptions || [],
      };
    },
  });
};
